<template>
    <a :class="type" @click="move">
        <span class="arrow" v-if="type === 'prev'">&#8592;</span>
        {{ text }}
        <span class="arrow" v-if="type === 'next'">&#8594;</span>
    </a>
</template>
<script>
import {mapMutations} from "vuex";

export default {
    props: {
        text: {
            type: String,
        },
        type: {
            type: String,
            default: () => 'next'
        },
    },
    methods: {
        ...mapMutations('cart', [
            'INCREMENT_STEP',
            'DECREMENT_STEP'
        ]),
        move() {
            if (this.type === 'prev') {
                this.DECREMENT_STEP()
            } else {
                this.INCREMENT_STEP()
            }
            return false;
        }
    },
}
</script>
